class CreatorInspirationGallery extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.buttons = this.querySelectorAll('.creator-gallery__trigger');
    this.buttons.forEach(button => {
      button.addEventListener('click', () => this.openModal(button));
    });

    this.modals = this.querySelectorAll('.creator-gallery__modal');
    this.modals.forEach(modal => {
      const closeBtn = modal.querySelector('.creator-gallery__modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => modal.close());
      }
      
      modal.addEventListener('click', (e) => {
        // If the click is not inside the modal-content (the video wrapper) and not the close button, close it
        if (!e.target.closest('.creator-gallery__modal-content video, .creator-gallery__modal-content img') && !e.target.closest('.creator-gallery__modal-close')) {
          modal.close();
        }
      });
      
      modal.addEventListener('close', (e) => this.handleClose(e));
    });
  }

  disconnectedCallback() {
    this.modals?.forEach(modal => {
      if (modal.open) modal.close();
      modal.querySelectorAll('video').forEach(video => video.pause());
    });
    document.body.classList.remove('creator-gallery-scroll-lock');
    this.activeTrigger = null;
  }

  openModal(trigger) {
    const modalId = trigger.getAttribute('data-modal-id');
    const modal = document.getElementById(modalId);
    if (!modal) return;
    
    this.activeTrigger = trigger;
    document.body.classList.add('creator-gallery-scroll-lock');
    modal.showModal();
    
    const video = modal.querySelector('.creator-gallery__modal-content video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  }

  handleClose(e) {
    document.body.classList.remove('creator-gallery-scroll-lock');
    const modal = e.target;
    const video = modal.querySelector('.creator-gallery__modal-content video');
    if (video) {
      video.pause();
    }
    if (this.activeTrigger) {
      this.activeTrigger.focus();
      this.activeTrigger = null;
    }
  }
}
if (!customElements.get('creator-inspiration-gallery')) {
  customElements.define('creator-inspiration-gallery', CreatorInspirationGallery);
}
